import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CanonicalService } from '../../shared/canonical.service';

@Component({
  selector: 'app-leadership-team',
  templateUrl: './leadership-team.component.html',
  styleUrls: ['./leadership-team.component.css']
})
export class LeadershipTeamComponent implements OnInit {

  heading = "Protectt.ai Leadership & Advisors";
  subheading = "Thought leaders working together to solve complex mobile cyber security challenges.";
  innerWidth:number = window.innerWidth;

  constructor(private titleService: Title, private metaTagService: Meta, private metaTagService1: Meta, private canonicalService: CanonicalService) {
    this.canonicalService.setCanonicalURL("https://www.protectt.ai/leadership-team");
   }

  ngOnInit(): void {
    this.titleService.setTitle('Leadership Team | Advisor | Protectt.ai');
    this.metaTagService1.updateTag({ name: 'title', content: 'Leadership and Advisors | Protectt.ai'});
    this.metaTagService.updateTag({ name: 'description', content: 'Meet Protectt.ai Corporate Leadership team and read about the depth of experience at the helm of Protectt.Our team working together to solve complex mobile cyber security challenges.'});
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
